import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3220187420/src/stell-adyen-demo/app/IndexPage.tsx");
